import { render } from "./CertAlcoholApprovedPending.vue?vue&type=template&id=b44f200a&scoped=true"
import script from "./CertAlcoholApprovedPending.vue?vue&type=script&lang=js"
export * from "./CertAlcoholApprovedPending.vue?vue&type=script&lang=js"

import "./CertAlcoholApprovedPending.vue?vue&type=style&index=0&id=b44f200a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44f200a"]])

export default __exports__